// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_g9-0";
export var fileCarousel = "_g9-2";
export var removeFileButton = "_g9-1";